import { sumBy, round } from 'lodash';
import { FundAllocation } from '../index';

// Calculate totals for current form values
export const calculateCurrentTotals = (
  fundIndex: number,
  watchedValues: { fundAllocations: Array<FundAllocation> },
  formFundAllocations: Array<FundAllocation>,
) => {
  const currentFundAllocation =
    watchedValues.fundAllocations?.[fundIndex] ??
    formFundAllocations[fundIndex];
  const investments = currentFundAllocation?.investments ?? [];

  const sharesAllocated = sumBy(investments, 'finalShareholding');
  const allocatedInvestment = investments.reduce((total, investment) => {
    const dealSharePrice = currentFundAllocation?.dealSharePrice ?? 0;
    return total + investment.finalShareholding * dealSharePrice;
  }, 0);
  const adjustedInvestment = sumBy(investments, 'adjustedNetInvestmentExFee');
  const transactionFee = sumBy(investments, 'transactionFeeAmount');

  // Calculate post-allocation deployable capital
  const postAllocationCapital = investments.reduce((total, investment) => {
    const investmentCapitalRemaining =
      investment.investmentCapitalRemaining ?? 0;
    const adjustedInvestmentValue = investment.adjustedNetInvestmentExFee ?? 0;
    const transactionFeeValue = investment.transactionFeeAmount ?? 0;
    const transactionFeeVat = round(
      (transactionFeeValue *
        (investment.defaultTransactionFeeVatPercent || 0)) /
        100,
      2,
    );
    const totalTransactionFee = transactionFeeValue + transactionFeeVat;

    return (
      total +
      (investmentCapitalRemaining -
        adjustedInvestmentValue -
        totalTransactionFee)
    );
  }, 0);

  return {
    sharesAllocated,
    allocatedInvestment,
    adjustedInvestment,
    transactionFee,
    postAllocationCapital,
  };
};

// Calculate totals for original values (previous total)
export const calculatePreviousTotals = (
  fundIndex: number,
  originalFundAllocations: Array<FundAllocation>,
) => {
  const originalFundAllocation = originalFundAllocations[fundIndex];
  const investments = originalFundAllocation?.investments ?? [];

  const sharesAllocated = sumBy(investments, 'finalShareholding');
  const allocatedInvestment = investments.reduce((total, investment) => {
    const dealSharePrice = originalFundAllocation?.dealSharePrice ?? 0;
    return total + investment.finalShareholding * dealSharePrice;
  }, 0);
  const adjustedInvestment = sumBy(investments, 'adjustedNetInvestmentExFee');
  const transactionFee = sumBy(investments, 'transactionFeeAmount');

  // Calculate post-allocation deployable capital
  const postAllocationCapital = investments.reduce((total, investment) => {
    const investmentCapitalRemaining =
      investment.investmentCapitalRemaining ?? 0;
    const adjustedInvestmentValue = investment.adjustedNetInvestmentExFee ?? 0;
    const transactionFeeValue = investment.transactionFeeAmount ?? 0;
    const transactionFeeVat = round(
      (transactionFeeValue *
        (investment.defaultTransactionFeeVatPercent || 0)) /
        100,
      2,
    );
    const totalTransactionFee = transactionFeeValue + transactionFeeVat;

    return (
      total +
      (investmentCapitalRemaining -
        adjustedInvestmentValue -
        totalTransactionFee)
    );
  }, 0);

  return {
    sharesAllocated,
    allocatedInvestment,
    adjustedInvestment,
    transactionFee,
    postAllocationCapital,
  };
};
